import React, {useEffect} from "react";
import { motion } from "framer-motion";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/about-breadcrumb.webp'
import { GandhidhamProducts, MundraProducts, products } from "../Data";
import { blogs } from "../Blog";

const Sitemap=()=>{
useEffect(() => {
            document.title =
              "SiteMap | Gurukrupa Wood Pvt. Ltd.";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "View the complete site map for Gurukrupa Wood Pvt. Ltd. Quickly find pages for custom wooden pallets, crates, services, and company info."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://gurukrupawood.com/sitemap");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "SiteMap | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "View the complete site map for Gurukrupa Wood Pvt. Ltd. Quickly find pages for custom wooden pallets, crates, services, and company info."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://gurukrupawood.com/sitemap");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://gurukrupawood.com/privacy-policy.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "SiteMap | Gurukrupa Wood Pvt. Ltd."
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Read the Privacy Policy of Gurukrupa Wood Pvt. Ltd. to understand how we collect, use and protect your information."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://gurukrupawood.com/privacy-policy.webp"
            );
          }
          }, []);

const containerVariant = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariant = {
    hidden: {
      opacity: 0,
      y: 60,
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: [0.22, 1, 0.36, 1],
      },
    },
  };
    return(
        <>
          <Breadcrumb
  pageName="Sitemap"
  bgImage={bgImg}
/>

 {/**PAGES LIST */}
    <section className="sitemap-section">
      <div className="container">

        <motion.h2
          className="section-heading"
          initial={{
            opacity: 0,
            y: 30,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
            amount: 0.3,
          }}
          transition={{
            duration: 0.8,
          }}
        >
          Explore All Pages on Our Website
        </motion.h2>

        <motion.div
          className="sitemap-grid"
          variants={containerVariant}
          initial="hidden"
          whileInView="visible"
          viewport={{
            once: true,
            amount: 0.1,
          }}
        >

          {/* Main Pages */}
          <motion.div
            className="sitemap-card"
            variants={cardVariant}
            whileHover={{
              y: -8,
              transition: {
                duration: 0.25,
              },
            }}
          >
            <h3 className="section-subheading">Main Pages</h3>

            <ul className="sitemap-links">
              <li><a href="/">Home</a></li>
              <li><a href="/about-us">About Us</a></li>
              <li><a href="/services">Services</a></li>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/products">Products</a></li>
              <li><a href="/contact-us">Contact Us</a></li>
            </ul>
          </motion.div>

          {/* Services */}
          <motion.div
            className="sitemap-card"
            variants={cardVariant}
            whileHover={{
              y: -8,
            }}
          >
            <h3 className="section-subheading">Products</h3>

            <ul className="sitemap-links">
              {products.map((item, i) => (
                <li key={i}>
                  <a href={`/products/${item.slug}`}>
                    {item.title}
                  </a>
                </li>
              ))}
              <li><a href="/products/customised-packaging">Customised Packaging</a></li>
            </ul>
          </motion.div>

            {/* Gandhidham */}
          <motion.div
            className="sitemap-card"
            variants={cardVariant}
            whileHover={{
              y: -8,
            }}
          >
            <h3 className="section-subheading">Wooden Products Manufacturer in Gandhidham</h3>

            <ul className="sitemap-links">
               <li><a href="/products/gandhidham">Products in Gandhidham</a></li>
              {GandhidhamProducts.map((item, i) => (
                <li key={i}>
                  <a href={`/products/${item.slug}`}>
                    {item.title}
                  </a>
                </li>
              ))}
             <li><a href="/products/customised-packaging-solution-in-gandhidham">Customised Packaging</a></li>
            </ul>
          </motion.div>

                  {/* Mundra */}
          <motion.div
            className="sitemap-card"
            variants={cardVariant}
            whileHover={{
              y: -8,
            }}
          >
            <h3 className="section-subheading">Wooden Products Manufacturer in Mundra</h3>

            <ul className="sitemap-links">
               <li><a href="/products/mundra">Products in Mundra</a></li>
              {MundraProducts.map((item, i) => (
                <li key={i}>
                  <a href={`/products/${item.slug}`}>
                    {item.title}
                  </a>
                </li>
              ))}
             <li><a href="/products/customised-packaging-solution-in-mundra">Customised Packaging</a></li>
            </ul>
          </motion.div>


          {/* Legal */}
          <motion.div
            className="sitemap-card"
            variants={cardVariant}
            whileHover={{
              y: -8,
            }}
          >
            <h3 className="section-subheading">
              Legal Information
            </h3>

            <ul className="sitemap-links">
              <li>
                <a href="/privacy-policy">
                  Privacy Policy
                </a>
              </li>

              <li>
                <a href="/terms-conditions">
                  Terms & Conditions
                </a>
              </li>
            </ul>
          </motion.div>

        </motion.div>


        {/* Blogs */}
          <motion.div
             className="sitemap-card blog-card"
            variants={cardVariant}
            whileHover={{
              y: -8,
            }}
          >
            <h3 className="section-subheading">Blogs</h3>

            <ul className="sitemap-links">
              {blogs.map((item, i) => (
                <li key={i}>
                  <a href={`/blog/${item.slug}`}>
                    {item.title}
                  </a>
                </li>
              ))}
            </ul>
          </motion.div>

      </div>
    </section>


        </>
    )
}
export default Sitemap;